module.exports = __webpack_public_path__ + "img/default_space_logo.4df303d3.png";